export var TypeActionEventInfo;
(function (TypeActionEventInfo) {
    TypeActionEventInfo["Request"] = "EventInfo > Request";
    TypeActionEventInfo["Received"] = "EventInfo > Received";
    TypeActionEventInfo["RemoveEvent"] = "EventInfo > RemoveEvent";
    TypeActionEventInfo["StartEvent"] = "EventInfo > StartEvent";
})(TypeActionEventInfo || (TypeActionEventInfo = {}));
export var actionEventInfoReceived = function (eventInfo) { return ({
    eventInfo: eventInfo,
    type: TypeActionEventInfo.Received,
}); };
export var actionEventInfoRemoveEvent = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionEventInfo.RemoveEvent,
}); };
export var actionEventInfoStartEvent = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionEventInfo.StartEvent,
}); };
export var actionEventInfoRequest = function () { return ({
    type: TypeActionEventInfo.Request,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/event/actionEventInfo.ts
// module id = 118
// module chunks = 3